<template>
  <validation-observer ref="simpleRules">
    <b-form @submit.prevent="validationForm">

      <!-- New Password -->
      <b-form-group
        label="Password Baru"
        label-for="v-new-password"
      >
        <validation-provider
          #default="{ errors }"
          name="Password Baru"
          rules="required|min: 8|password"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="v-new-password"
              v-model="form.password"
              :type="passwordFieldTypeNew"
              placeholder="Your Password"
            />
            <b-input-group-append is-text>
              <feather-icon
                :icon="passwordNewToggleIcon"
                class="cursor-pointer"
                @click="togglePasswordNew"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Confirm New Password -->
      <b-form-group
        label="Konfirmasi Password"
        label-for="v-confirm-password"
      >
        <validation-provider
          #default="{ errors }"
          name="Konfirmasi Password"
          rules="required|min: 8|password|confirmed:Password Baru"
        >
          <b-input-group class="input-group-merge">
            <b-form-input
              id="v-confirm-password"
              v-model="form.confirm_password"
              :type="passwordFieldTypeRetype"
              placeholder="Konfirmasi Password"
            />
            <b-input-group-append is-text>
              <feather-icon
                :icon="passwordConfirmToggleIcon"
                class="cursor-pointer"
                @click="togglePasswordRetype"
              />
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <!-- Button -->
      <div class="d-flex justify-content-end mt-3 mb-1">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          :disabled="isSubmitting"
        >
          <b-spinner
            v-if="isSubmitting"
            small
          />
          {{ isSubmitting ? "Menyimpan" : "Simpan" }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { mapActions } from 'vuex'
import {
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BInputGroupAppend,
  BInputGroup,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BInputGroupAppend,
    BInputGroup,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        password: '',
        confirm_password: '',
      },
      required,
      isPending: false,
      isSubmitting: false,
      passwordFieldTypeOld: 'password',
      passwordFieldTypeNew: 'password',
      passwordFieldTypeRetype: 'password',
    }
  },
  computed: {
    passwordOldToggleIcon() {
      return this.passwordFieldTypeOld === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordNewToggleIcon() {
      return this.passwordFieldTypeNew === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    passwordConfirmToggleIcon() {
      return this.passwordFieldTypeRetype === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
    ...mapActions('brand', ['changePassword']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      await this.changePassword({ idBrand: this.data.id, data: this.form })

      this.isSubmitting = false
      this.$emit('finish')
    },
    togglePasswordOld() {
      this.passwordFieldTypeOld = this.passwordFieldTypeOld === 'password' ? 'text' : 'password'
    },
    togglePasswordNew() {
      this.passwordFieldTypeNew = this.passwordFieldTypeNew === 'password' ? 'text' : 'password'
    },
    togglePasswordRetype() {
      this.passwordFieldTypeRetype = this.passwordFieldTypeRetype === 'password' ? 'text' : 'password'
    },
  },
}
</script>
